export function extractNationalPart(e164: string, countryPhoneCode?: string): string | null {
  if (countryPhoneCode && e164.startsWith('+' + countryPhoneCode)) {
    const part = e164.slice(1 + countryPhoneCode.length);
    return part.length > 0 ? part : null;
  }
  // CC unknown: try longest prefix first (3→1) to avoid over-stripping.
  // Require length >= 2 to avoid single-digit false positives.
  const digitsAfterPlus = e164.slice(1);
  for (let ccLen = 3; ccLen >= 1; ccLen--) {
    const part = digitsAfterPlus.slice(ccLen);
    if (part.length >= 2) return part;
  }
  return null;
}
